export enum EFetchOutcome {
  UNDEFINED = 'undefined',
  SHOW_FALLBACK = 'show-fallback',
  SHOW_CONTENT = 'show-content',
}
